import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { BankStatementEntry, BankStatementEntryCreate, BankStatementEntryFilter } from '../data/bankStatementEntry';

export function createBankStatementEntryService(client: AxiosInstance) {
  return createCrudService<BankStatementEntry, BankStatementEntryCreate, BankStatementEntryFilter>(
    client,
    '/accounting/BankStatementEntry',
    'id',
  );
}

export type BankStatementEntryService = CrudService<BankStatementEntry, BankStatementEntryCreate, BankStatementEntryFilter>;
